export const colors = [
  ["прозрачный", "#f0f0f0", "white"],
  ["белый", "#ffffff", "white"],

  ["розовый", "#f59bbb", "color"],
  ["красный", "#d22730", "color"],
  ["бордовый", "#782f40", "color"],
  ["светло-бежевый", "#f5e1a4", "color"],
  ["оранжевый", "#fc4c02", "color"],
  ["коричневый", "#623b2a", "color"],
  ["жёлтый", "#ffc72c", "color"],
  ["салатовый", "#00ad50", "color"],
  ["зелёный", "#007a33", "color"],
  ["тёмно-зелёный", "#004e42", "color"],
  ["голубой", "#00a9e0", "color"],
  ["голубой металлик", "#007dba", "color"],
  ["бирюзовый", "#007c80", "color"],
  ["синий", "#0057b7", "color"],
  ["тёмно-синий", "#141b4d", "color"],
  ["фиолетовый", "#440099", "color"],
  ["чёрный", "#2d2926", "color"],

  ["серебро", "#8a8d8f", "gold"],
  ["золото", "#866d4b", "gold"],
].map(([name, value, group]) => ({ name, value, group }));

export function groupOfColor(name) {
  return colors.find((c) => c.name === name)?.group;
}

export function colorsOfGroup(groupName) {
  return colors.filter((c) => c.group === groupName);
}
